import request, { RequestOptionConfig } from '../request';
import Queue from '../sdk/Queue';
import { configData, generateConfigValue, Task } from './utils';
export enum IConfigKey {
  commonAutowrap = 'common.autowrap', // 是否折行
  commonOpenmethod = 'common.openmethod', // 打开方式
  commonMenuExpandType = 'common.menuExpandType', // 菜单展开收起方式
  commonBatchFirstPageSelected = 'common.batchFirstPageSelected', // 批量操作首页默认选中
  commonSearchHidePanel = 'common.searchHidePanel', // 批量操作首页默认选中
}

class BaseConfig {
  public configIsReady: boolean = false;

  public configValue: any = {};

  public readyQueue = new Queue<Task>();

  initConfg = () => {
    this.readyConfig();
    try {
      const broadCastChannel = new BroadcastChannel("baseConfig");
      broadCastChannel.onmessage = (e) => {
          if (e.data?.value) {
            this.configValue = e.data?.value;
          }
      }  
    } catch (error) {
      console.error(error);
    }
    
  };

  // 更新配置的方法
  updateConfig = (configValue: any) => {
    try {
      const broadCastChannel = new BroadcastChannel("baseConfig");
      broadCastChannel.postMessage({
        value : configValue
      })  
    } catch (error) {
      console.error(error)
    }
    
    this.configValue = configValue;
  };

  successCallback = () => {
    // 09/25 调整 默认不传递参数的情况下 查询所有设置项
    const options: RequestOptionConfig = {
      url: `/api/component/base/syncSetting/getSetting`,
      method: 'POST',
      data: {
        data: []
      }
    };
    return request(options);
  };

  readyConfig = () => {
    if (window?.TEAMS?.ready && typeof window.TEAMS.ready === 'function') {
      // 通过 TEAMS 获取
      window.TEAMS.ready('TEAMS', {
        success: () => {
          this.successCallback().then(
            (res) => {
              if (res && res.data) {
                this.configValue = generateConfigValue(res.data) || {};
              }
              this.configIsReady = true;
              this.invokeReady();
            },
            // 异常的时候 404 的兼容处理
            () => {
              this.configIsReady = true;
              this.invokeReady();
            }
          );
        },
        failed: (error: any) => {
          this.configIsReady = true;
          this.invokeReady();
        },
      });
    } else {
      this.configIsReady = true;
      this.invokeReady();
    }
  };

  private invokeReady = (failed?: boolean) => {
    while (!this.readyQueue.isEmpty()) {
      const task = this.readyQueue.pop();
      if (failed) {
        task?.reject();
      } else {
        task?.func(this);
        task?.resolve(this);
      }
    }
  };

  ready = (func: Function) => {
    return new Promise((resolve, reject) => {
      if (!func || typeof func !== 'function'){
        reject('ready 需要接受function 作为参数');
        return;
      }
      if (this.configIsReady && this.configValue) {
        func(this);
        resolve(this);
        return;
      }

      this.readyQueue.push({ func, resolve, reject });
    });
  };
}

export const baseConfigInstance = new BaseConfig();

baseConfigInstance.initConfg();

export default BaseConfig;
